import React, { Component } from "react";
import moment from "moment";
import {
  Button,
  Col,
  Row,
  NavLink,
  NavItem,
  Nav,
  Input,
  Label,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { amButtonLabels } from "../../ShortFunction/shortFunctions";
import "./formsTable.css";
import "./baseForms.css";
import { Redirect, Link } from "react-router-dom";
import Swal from "sweetalert2";
import ActivityLogs from "../../ShortCutComponents/ActivityLogs";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import {
  checkPermission,
  check_Bussiness_Permission,
  priorityLov,
} from "../../../../Helper";
import swal from "@sweetalert/with-react";
import "./myReactSelect.css";
import "../../../../index.css";
import "react-datepicker/dist/react-datepicker.css";
import bar1 from "./../../../../assets/img/brand/Rectangle24.png";
import bar2 from "./../../../../assets/img/brand/Rectangle25.png";
import bar4 from "./../../../../assets/img/brand/Rectangle27.png";
import layer1 from "./../../../../assets/img/brand/layer1.png";
import calender from "./../../../../assets/img/brand/calender4.png";
import clock from "./../../../../assets/img/brand/clock.png";
import tooltipText from "../../ShortCutComponents/tooltipText";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Responseloader from "../../ShortCutComponents/ResponseLoader";
import {
  companyCurrencySymbol,
  headers,
  token,
  companyId,
  username,
} from "../../../../utils/variables";
import ReactDatePicker from "../../ShortCutComponents/ReactDatePicker";
import { GrAttachment } from "react-icons/gr";
import AttachmentViewModal from "./../../../Forms/ShortCutComponents/AttachmentViewModal";
import SearchBar from "../../ShortCutComponents/SearchBar";
import GrnTrackingModal from "../../ShortCutComponents/GrnTrackingModal";
let companyNameParam = localStorage.getItem("companyName");

var thisContext;

function addZeroTFormator(cell, row, enumObject, index) {
  let newCell = "";
  if (cell > 0 && cell < 10) {
    newCell = "00" + cell;
  } else if (cell >= 10 && cell < 100) {
    newCell = "0" + cell;
  } else {
    newCell = cell;
  }

  return <div>{newCell}</div>;
}
const lineTypeLov = [
  { id: null, value: null, label: "ALL" },
  { id: 0, value: 0, label: "Item" },
  { id: 1, value: 1, label: "Expense" },
];
const itemTypeLov = [
  { id: 1, value: 1, label: "Inventory PD" },
  { id: 2, value: 2, label: "General PD" },
];
const expenseTypeLov = [{ id: 3, value: 1, label: "Expense PD" }];
function calculateDaysLeft(startDatee, endDatee) {
  if (!moment.isMoment(startDatee)) startDatee = moment(startDatee);
  if (!moment.isMoment(endDatee)) endDatee = moment(endDatee);

  var res = endDatee.diff(startDatee, "days");
  return res;
}
function dueFormatorsComma(cell, row, enumObject, index) {
  let cett = "";
  if (cell) {
    cett = cell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    cett = companyCurrencySymbol + " " + cett;
  } else {
    cett = 0;
  }

  return cett;
}
function dueFormatorsComma2(cell, row, enumObject, index) {
  let cett = "";
  cett = parseFloat(cell);
  if (cell) {
    cett = cett?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    // cett =cett;
  } else {
    cett = 0;
  }

  return cett;
}
function dueFormator(cell, row, enumObject, index) {
  let newCell = "";
  if (typeof cell === "string") {
    cell = parseFloat(cell);
  }
  newCell = cell?.toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  if (newCell === null || newCell === undefined) {
    newCell = 0;
  }
  newCell = thisContext.state.curDesc + " " + newCell;
  return newCell;
}

const columnHover = (cell, row, enumObject, rowIndex) => {
  if (row.SHORT_DESC === "PUR_RET") {
    return (
      "Purchase CreditNote Amount= " +
      dueFormator(row.functionalAmount) +
      "\nApply Purchase Credit Amount= " +
      dueFormator(row.creditNotAmount) +
      "\nSupplier Refund Applied Amount= " +
      dueFormator(row.refundAmount)
    );
  } else if (row.SHORT_DESC === "PUR") {
    return (
      "Purchase Amount= " +
      dueFormator(row.functionalAmount) +
      "\nSupplier Payments= " +
      dueFormator(row.payment) +
      "\nPurchase Credit Note Amount= " +
      dueFormator(row.totalCreditNoteAmount)
    );
  }
};
class Overview extends Component {
  constructor(props) {
    super(props);
    thisContext = this;
    let tempLogedIn = false;
    let defaultdate = new Date();
    defaultdate = moment(defaultdate).format("YYYY-MM-DD");
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }

    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      activeTab: new Array(6).fill("All"),
      logInStatus: tempLogedIn,
      invoiceIdState: "",
      currencyId: "",
      activityModelIsOpen: false,
      isKarakKhel: false,
      divcontainer: false,
      permission: true,
      rolesPermission: false,
      defaultdate: defaultdate,
      transactionLov: [],
      currencySymbol: "",
      remarks: "",
      closeDate: new Date(),
      currentDate: new Date(),
      redirect: false,
      loadingResponce: false,
      redirectSomeOnePaid: false,
      redirectToCreativeInvoice: false,
      idEdit: "",
      linkTo: "",
      pageCounter: 1,
      redirectSupplier: false,
      redirectCreditNoteApp: false,
      closePoModelIsOpen: false,
      logPoModelIsOpen: false,
      sendJournalId: "",
      pageSize: "",
      offSet: "",
      isAllData: false,
      dataShowPerPage: "",
      purchaseCount: "",
      overdueDataCount: "",
      dueDataCount: "",
      dataPaidCount: "",
      priority: null,
      demandType: null,
      costCenter: null,
      lineType: "0",
      demandTypeLov: [],
      checkLineType: null,
      showAttachmentModal: false,
      selectedRowDetails: null,
      branch: null,
      authStatus: null,
      isEggPagination: false,
      grnTrackingModalOpen: false,
      grnTrackingData: [],
      grnTrackingTotalPO: 0,
      searchCategory: { value: "all", label: "All" },
      searchTerm: "",
      searchOptions: [
        { value: 0, label: "All", placHolder: "Search..." },
        {
          value: 1,
          label: "Name",
          placHolder: "Enter Name...",
        },
        {
          value: 2,
          label: "Doc No",
          placHolder: "Enter Doc No...",
        },
        {
          value: 3,
          label: "ISSUED",
          placHolder: "DD-MMM-YYYY (e.g. 12-May)",
        },
      ],
    };
  }
  asyncRollCheck2 = async (value) => {
    let pathname = "/PurchaseOrder/form";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  setDelete = async (row) => {
    const deleteCheck = await this.asyncRollCheck(3);
    if (deleteCheck) {
      return;
    }
    let id = row.purch_order_id;
    let type = row.SHORT_DESC;
    let jr_id = row.JOURNAL_ID;
    let billDate = row.bill_date;
    billDate = moment(billDate).format("YYYY-MM-DD");
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deletePurchaseOrder`,
            {
              DeleteId: id,
              invoice_date: billDate,
              type,
              journalId: jr_id,
              username,
              companyId,
            },
            headers,
          )
          .then((response) => {
            if (response.data.message === "Delete success") {
              Swal.fire("Deleted!", "Your Record has been deleted.", "success");
              thisContext.getOverviewData("All", "All");
            }
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  ///////////-----END------////////////////////////////////
  setDlt = (row) => {
    let id = row.purch_order_id;
    let type = row.SHORT_DESC;
    let jr_id = row.JOURNAL_ID;
    let billDate = row.bill_date;
    billDate = moment(billDate).format("YYYY-MM-DD");

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deleteMillage`,
            {
              DeleteId: id,
              invoice_date: billDate,
              type: type,
              journalId: jr_id,
              username: username,
              companyId: companyId,
            },
            headers,
          )
          .then((response) => {
            if (response.data.message === "success") {
              Swal.fire(
                "Deleted!",
                type === "M"
                  ? "Millage has been deleted."
                  : "Subsistence has been deleted.",
                "success",
              );
              thisContext.getOverviewData("All", "All");
            }
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  closePo = () => {
    const { closeDate, remarks, orderId } = this.state;
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Close PO!",
    }).then((result) => {
      if (result) {
        axios
          .post(
            `${baseurl}/masterData/closePurchaseOrder`,
            {
              id: orderId,
              date: closeDate,
              remarks: remarks,
              username: username,
              companyId: companyId,
            },
            headers,
          )
          .then((response) => {
            if (response.data.message === "success") {
              Swal.fire(
                "Closed!",
                "Your Purchase Order has been closed.",
                "success",
              );

              thisContext.toggleClosePoModal();
              thisContext.getOverviewData("All", "All");
            }
          })
          .catch((err) => {
            console.log("Close PO error:", err.response?.data);

            if (err.response?.data?.sendForApp === "1") {
              Swal.fire({
                title: "Error!",
                text: err.response.data.message,
                icon: "error",
              });
            } else {
              Swal.fire({
                title: "Failed!",
                text:
                  err.response?.data?.message ||
                  "Something went wrong while closing the PO.",
                icon: "error",
              });
            }
          });
      }
    });
  };
  amAuth = (row) => {
    const { branch } = thisContext.state;
    thisContext.setState({ loadingResponce: true });
    if (row.am_status === 2 || row.am_status === 5) {
      const resultRemoveData = axios.post(
        `${baseurl}/Authorizer/checkAndDeleteDoc`,
        {
          companyId: companyId,
          id: row.purch_order_id,
          book_id: row.inv_book_id,
          sub_inv_id: row.sub_inv_id,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );
      resultRemoveData
        .then(function (res) {
          const data = res.data.data?.count_of_marked_records;
          swal({
            title: "Successfully Revoked!",
            text: "Revoked",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        })
        .catch(function (error) {
          if (error.response) {
            swal({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              timer: 3000,
              showConfirmButton: false,
            });
          } else {
            console.log("Error:", error.message);
          }
        })
        .finally(() => {
          thisContext.setState({ loadingResponce: false });
          thisContext.getOverviewData("All", "All", null, branch?.id);
        });
    } else {
      axios
        .post(
          `${baseurl}/Authorizer/am_SendForAuth`,
          {
            companyId: companyId,
            // date: row.bill_date,
            date: moment().format("YYYY-MM-DD"),
            id: row.purch_order_id,
            book_id: row.inv_book_id,
            sub_inv_id: row.sub_inv_id,
            username: username,
          },
          {
            headers: {
              authorization: token,
            },
          },
        )

        .then(function (res) {
          thisContext.setState({ loadingResponce: false });
          const data = res.data.data;
          console.log("hellll", res, data);
          if (data) {
            swal({
              title: "Saved Successfully!",
              text: "Added",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
            setTimeout(() => {
              thisContext.getOverviewData("All", "All", null, branch?.id);
            }, 2000);
          } else {
            swal({
              title: "Send for App",
              text: "this doc is not submitted!.",
              icon: "warning",
              timer: 2000,
              showConfirmButton: false,
            });
          }
        })
        .catch(function (error) {
          console.log("popopo", error);
          console.log(error.response.data.message);
          swal({
            title: "Error",
            text:  `${error.response.data.message}` ||`Some Thing Went Wrong. Try Again Later!`,
            icon: "warning",
            timer: 2000,
            showConfirmButton: false,
          });
          thisContext.setState({ loadingResponce: false });
          console.log(error);
        });
    }
  };

  // Log modal toggle function
  toggleLogPoModal = (id) => {
    id && thisContext.setState({ loadingResponce: true });
    this.setState({
      logPoModelIsOpen: !this.state.logPoModelIsOpen,
    });
    id &&
      axios
        .post(
          `${baseurl}/subsistence/getPurchaseOrderLog`,
          {
            companyId,
            username,
            id,
          },
          headers,
        )
        .then(function (res) {
          const { TotalAmount, balanceAmount, records } = res.data.data;
          console.log("res ", res.data.data);
          thisContext.setState({
            TotalAmount,
            balanceAmount,
            records,
            loadingResponce: false,
          });
        })
        .catch((error) => {
          console.log(error);
        });
  };
  // close po modal toggle function
  toggleClosePoModal = async () => {
    const closePO = await this.asyncRollCheck2(2);
    if (closePO) {
      return;
    }
    this.setState({
      closePoModelIsOpen: !this.state.closePoModelIsOpen,
      remarks: "",
    });
  };
  togglePermission() {
    thisContext.setState({
      showPermissionModal: !thisContext.state.showPermissionModal,
    });
  }
  funPrintView = (name, row) => {
    console.log("row", row);
    this.setState({
      invoiceId: row.purch_order_id,
      companyId: companyId,
      redirectToPrint: 1,
      headerPrefix: name,
    });
  };
  redirectToOrder = (cell, row) => {
    if (row.SHORT_DESC === "PUR_RET" && cell === "purRefund") {
      this.setState({
        redirectToRefund: true,
        supp_id: row.mainId,
        amount: row.bill_amount,
        pur_ret_id: row.purch_order_id,

        supp_name: row.name,
        pur_inv_date: new Date(row.dueDate),
        companyCurSymbol: row.currencySymbol,
        currencyId: row.currencyId,
        inv_doc_no: row.doc_no,
        conv_rate: row.conv_rate,
      });
    } else if (cell === "update" && row.SHORT_DESC === "SUB") {
      this.setState({
        redirect: true,
        idEdit: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        currencySymbol: row.currencySymbol,
        updateCheck: 0,
      });
    } else if (cell === "update") {
      this.setState({
        redirectPurchBill: true,
        idEdits: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 0,
      });
    } else if (cell === "againstPo") {
      if (row.am_status === 4 || row.am_status === 0) {
        this.setState({
          redirectPurchaseOrderAgainst: true,
          idEdits: row?.purch_order_id,
          sendJournalId: row.JOURNAL_ID,
          updateCheck: 2,
        });
      } else {
        swal({
          title: "Not Approved",
          text: `Pending For Approval!`,
          icon: "warning",
          timer: 2000,
          buttons: false,
        });
      }
    } else if (cell === "againstPoKK") {
      if (row.am_status === 4 || row.am_status === 0) {
        this.setState({
          redirectPurchaseOrderAgainstKK: true,
          idEdits: row?.purch_order_id,
          sendJournalId: row.JOURNAL_ID,
          updateCheck: 2,
        });
      } else {
        swal({
          title: "Not Approved",
          text: `Pending For Approval!`,
          icon: "warning",
          timer: 2000,
          buttons: false,
        });
      }
    }
    // else if (cell === "view" && row.SHORT_DESC === "PUR_RET") {// ispr conflict aia tha to haider bhai ne mere anydesk pr akr solve kai he 19-Dec-25
    //   this.setState({
    //     redirectPurchaseOrderAgainst: true,
    //     idEdits: row?.purch_order_id,
    //     sendJournalId: row.JOURNAL_ID,
    //     updateCheck: 2,
    //   });
    // }
    else if (cell === "againstPoToGrn") {
      this.setState({
        redirectPoToGrn: true,
        idEdits: row?.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 66,
      });
    }
    // else if (cell === "view" && row.SHORT_DESC === "PUR_RET") {
    //   this.setState({
    //     redirectPurchCrdBill: true,
    //     idEdits: row.purch_order_id,
    //     sendJournalId: row.JOURNAL_ID,
    //     updateCheck: 2,
    //   });
    // }
    else if (cell === "update" && row.SHORT_DESC === "M") {
      this.setState({
        redirectMileage: true,
        idEditM: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 0,
      });
    } else if (cell === "update" && row.T === "PR") {
      this.setState({
        redirectPRec: true,
        idEditPRec: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 0,
      });
    } else if (cell === "view" && row.SHORT_DESC === "SUB") {
      this.setState({
        redirect: true,
        idEdit: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 2,
      });
    } else if (cell === "view") {
      this.setState({
        redirectPurchBill: true,
        idEdits: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 2,
      });
    } else if (cell === "showPurchase") {
      this.setState({
        redirectPurchase: true,
        idEdits: row?.PURCH_INVOICE_ID,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 2,
      });
    } else if (cell === "view" && row.SHORT_DESC === "M") {
      this.setState({
        redirectMileage: true,
        idEditM: row.purch_order_id,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 1,
      });
    } else if (cell === "view" && row.T === "PR") {
      this.setState({
        redirectPRec: true,
        idEditPRec: row.PURCH_REC_MT_ID,
        sendJournalId: row.JOURNAL_ID,
        updateCheck: 2,
      });
    }
  };
  redirectToOrderRem = (cell, row) => {
    if (cell === "updateRemb") {
      // console.log("supplierRow", row);
      this.setState({
        redirectSupplier: true,
        amount: row.bill_amount,
        idSupplier: row.mainId,
        currencySymbol: row.currencySymbol,
        purchInvId: row.PURCH_INVOICE_ID,
        propSendCurrId: row.currencyId,
        updateCheck: 2,
      });
    }
  };

  redirectToCreditNote = (cell, row) => {
    this.setState({
      redirectCreditNoteApp: true,
      amount: row.bill_amount,
      currencyId: row.currencyId,
      idSupplier: row.mainId,
      purchInvId: row.purch_order_id,
      updateCheck: 2,
      currencySymbol: row.currencySymbol,
    });
    // }
  };
  handleToChangeOpen = (e, name) => {
    this.setState({ [name]: e });
    // if (demandType) {
    //   this.getPoOverviewData(null, demandType.id);
    // } else {
    //   this.getPoOverviewData();
    // }
  };
  handleLineChange = (e) => {
    console.log("e", e.target.value);
    let lineType = e.target.value ? e.target.value : null;
    let demObj = null;
    let lov = this.state.demandTypeLov;
    if (lineType == 0) {
      lov = itemTypeLov;
    } else if (lineType == 1) {
      lov = expenseTypeLov;
      demObj = expenseTypeLov[0];
    }
    this.setState({ lineType, demandType: demObj, demandTypeLov: lov });
    // if (lineType) {
    //   this.getPoOverviewData(null, lineType.id);
    // } else {
    //   this.getPoOverviewData();
    // }
  };

  getDemandTypeLov = () => {
    axios
      .post(
        `${baseurl}/lovs/getDemandTypeLov`,

        {
          companyId: companyId,
          username: username,
          // custCheck: true,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then(function (response) {
        let responseData = response.data.data;

        thisContext.setState({
          demandTypeLov: responseData,
        });
      })
      .catch(function (error) {
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
        console.log(error);
      });
  };
  showAuthRemarks = (remarks) => {
    Swal.fire({
      title: "Authorization Remarks",
      text: remarks,
      icon: "info",
      confirmButtonColor: "#3085d6",
    });
  };

  handleAuthStatusChange = (status) => {
    this.setState({ authStatus: status }, () => {
      if (status && this.state.branch?.id) {
        this.getOverviewData("", "", "", this.state.branch?.id, status?.value);
      } else if (!this.state.branch?.id) {
        swal({
          title: "Info!",
          text: "Please select branch",
          icon: "error",
        });
      }
    });
  };

  authoptions = [
    { value: "All", label: "-- All Status --" },
    { value: 1, label: "Send For Approval" }, //authsts = 1
    { value: 2, label: "Revoke" }, //authsts = 2
    { value: 3, label: "Processing" }, //authsts = 3
    { value: 4, label: "Approved" }, //authsts = 4
    { value: 5, label: "Rejected" }, //authsts = 5
  ];
toggleGrnTrackingModal = () => {
    this.setState({ grnTrackingModalOpen: !this.state.grnTrackingModalOpen });
  };

  fetchGrnTracking = (row) => {
    this.setState({ loadingResponce: true });
    
    axios
      .post(
        `${baseurl}/masterData/getPoGrnTracking`,
        {
          companyId: companyId,
          username: username,
          purch_order_id: row.purch_order_id,
        },
        headers
      )
      .then((res) => {
        const responseData = res.data.data;
        
        // Group the flat SQL data by PO Detail ID to handle the RowSpans perfectly
        const groupedData = responseData.reduce((acc, current) => {
          if (!acc[current.purch_order_det_id]) {
            acc[current.purch_order_det_id] = {
              Code: current.Code || "",
             Item_Name: current.Item_Name || null,      
              Expense_Name: current.Expense_Name || null,
              PO_Qty: Number(current.PO_Qty || 0),
              total_GRN: 0,
              grns: []
            };
          }
          if (current.GRN_No) {
            acc[current.purch_order_det_id].grns.push({
              GRN_Date: current.GRN_Date,
              GRN_No: current.GRN_No,
              GRN_Qty: Number(current.GRN_Qty || 0)
            });
            acc[current.purch_order_det_id].total_GRN += Number(current.GRN_Qty || 0);
          }
          return acc;
        }, {});

        const processedData = Object.values(groupedData);
        const totalPoQty = processedData.reduce((sum, item) => sum + item.PO_Qty, 0);

        this.setState({
          grnTrackingData: processedData,
          grnTrackingTotalPO: totalPoQty,
          grnTrackingModalOpen: true,
          loadingResponce: false,
        });
      })
      .catch((err) => {
        this.setState({ loadingResponce: false });
        console.log(err);
        Swal.fire("Error", "Failed to load GRN details", "error");
      });
  };
  statusFormator = (cell, row) => {
    let hasAttachment = false;
    if (row.attachment_file) {
      const rawVal = row.attachment_file.toString().trim();
      if (rawVal !== "" && rawVal !== "[]") {
        if (rawVal.startsWith("[") && rawVal.endsWith("]")) {
          try {
            const parsed = JSON.parse(rawVal);
            if (Array.isArray(parsed) && parsed.length > 0) {
              if (parsed.some((f) => f && f.trim() !== ""))
                hasAttachment = true;
            }
          } catch (e) {
            hasAttachment = true;
          }
        } else {
          hasAttachment = true;
        }
      }
    }
    const { ORDER_STATUS } = row;
    // console.log("row", row);
    const { rolesPermission } = thisContext.state;
    let today = thisContext.state.defaultdate;
    cell = moment(cell).format("YYYY-MM-DD");
    let daysLeft = calculateDaysLeft(today, cell);
    let button = row.am_status;
    let buttonName, buttonTooltip, buttonDisable, iconName, iconTitle;
    const isSendForApp = button === 1;
    const isRevoked = button === 2;
    const isProcessing = button === 3;
    const isApproved = button === 4;
    const isRejected = button === 5;
    if (button) {
      let buttonInfo = amButtonLabels(button);
      buttonName = buttonInfo.buttonName;
      buttonTooltip = buttonInfo.tooltip;
      buttonDisable = buttonInfo.disable;
      iconName = buttonInfo.iconName;
      iconTitle = buttonInfo.iconTitle;
    }
    return (
      <div>
        {button ? (
          <>
            <span>
              <img
                src={iconName}
                alt="Processing"
                title={iconTitle}
                style={{ width: "20px", height: "20px", marginRight: "8px" }}
              />
            </span>
            <span>
              <Button
                className="mr-1"
                size="sm"
                title={buttonTooltip}
                color="success"
                onClick={() => {
                  this.amAuth(row);
                }}
                disabled={buttonDisable || row?.ORDER_STATUS === "Closed"}
              >
                {/* <img
                  src={iconName}
                  alt="Processing"
                  title={iconTitle}
                  style={{ width: "20px", height: "20px", marginRight: "8px" }}
                /> */}
                {buttonName}
              </Button>
            </span>
          </>
        ) : null}
        <span>
          <Button
            className="mr-1"
            size="sm"
            title="Print PO"
            color="primary"
            onClick={() => {
              this.funPrintView("Purchase Order", row);
            }}
          >
            <i className="fa fa-print"></i>
          </Button>
        </span>
        {cell !== "Invalid date" &&
        row.bill_amount > 0 &&
        (row.SHORT_DESC === "PUR" ||
          row.SHORT_DESC === "PUR_RET" ||
          row.SHORT_DESC === "PR") ? (
          cell !== "Invalid date" && daysLeft >= 0 ? (
            <span className="mr-1 badge badge-warning">
              {daysLeft === 0 ? "due today" : daysLeft + " days left"}
            </span>
          ) : (
            <span className="mr-1 badge badge-danger">
              {Math.abs(daysLeft)} days over{" "}
            </span>
          )
        ) : (
          <span
            className={`mr-1 badge  ${
              ORDER_STATUS === "Completed"
                ? "badge-success"
                : ORDER_STATUS === "Closed"
                  ? "badge-danger"
                  : "badge-warning"
            }`}
          >
            {" "}
            {row?.ORDER_STATUS}
          </span>
        )}

        <Button
          type="submit"
          size="sm"
          className="m-1"
          color="warning"
          title={tooltipText.update}
          disabled={
            row?.ORDER_STATUS === "Closed" ||
            row?.PUR_AMT > 0 ||
            isRevoked ||
            isProcessing ||
            isApproved ||
            isRejected
          }
          onClick={() => {
            this.redirectToOrder("update", row);
          }}
        >
          Edit
        </Button>
        <Button
          type="button"
          className="m-1"
          size="sm"
          color="success"
          title="PO to GRN Tracking"
          hidden={!this.state.isCrumble}
          onClick={() => this.fetchGrnTracking(row)}
        >
          <i className="fa fa-list"></i> GRN Info
        </Button>
        <Button
          type="submit"
          className="m-1"
          size="sm"
          color="primary"
          hidden={this.state.isKarakKhel}
          // title="Purchase Against Order"
          title="Com. GRN"
          disabled={
            row?.ORDER_STATUS === "Closed" ||
            row?.ORDER_STATUS === "Completed" ||
            isSendForApp ||
            isRevoked ||
            isProcessing ||
            isRejected
          }
          onClick={() => {
            this.redirectToOrder("againstPo", row);
          }}
        >
          {/* Purchase */}
          Com. GRN
        </Button>
        <Button
          type="submit"
          className="m-1"
          hidden={!this.state.isKarakKhel}
          size="sm"
          color="primary"
          // title="Purchase Against Order"
          title="Com. GRN"
          disabled={
            row?.ORDER_STATUS === "Closed" || row?.ORDER_STATUS === "Completed"
          }
          onClick={() => {
            this.redirectToOrder("againstPoKK", row);
          }}
        >
          {/* Purchase (ye karakkhel k lie he ) */}
          Com. GRNkk
        </Button>
        {/* <Button
          type="submit"
          className="m-1"
          size="sm"
          color="info"
          // title="Purchase Against Order"
          title="GRN"
          disabled={
            row?.ORDER_STATUS === "Closed" || row?.ORDER_STATUS === "Completed"
          }
          onClick={() => {
            this.redirectToOrder("againstPoToGrn", row);
          }}
        > 
          GRN
        </Button> */}
        <Button
          type="submit"
          disabled={
            row?.ORDER_STATUS === "Closed" ||
            row?.PUR_AMT > 0 ||
            isRevoked ||
            isProcessing ||
            isApproved ||
            isRejected
          }
          className="m-1"
          size="sm"
          color="danger"
          title={tooltipText.delete}
          onClick={() => this.setDelete(row)}
        >
          Delete
        </Button>
        <Button
          type="submit"
          className="m-1"
          size="sm"
          color="danger"
          title={`Remarks:${row.close_remarks ? row.close_remarks : ""}`}
          disabled={
            row?.ORDER_STATUS === "Closed" ||
            row?.ORDER_STATUS === "Completed" ||
            row?.show_close ||
            isRevoked ||
            isProcessing
          }
          onClick={() => {
            this.setState({ orderId: row.purch_order_id });
            this.toggleClosePoModal();
          }}
        >
          Close PO
        </Button>
        <Button
          type="submit"
          className="m-1"
          size="sm"
          color="info"
          title={`Remarks:${row.close_remarks ? row.close_remarks : ""}`}
          onClick={() => {
            this.setState({ orderId: row.purch_order_id });
            this.toggleLogPoModal(row.purch_order_id);
          }}
        >
          Log
        </Button>
        <Button
          type="submit"
          className="m-1"
          size="sm"
          color="info"
          disabled={this.state.rolesPermission}
          onClick={() => {
            this.setState({ orderId: row.purch_order_id });
            this.toggleActivityModel(row);
          }}
        >
          Activity
        </Button>
        {row.auth_remarks && (
          <span>
            <Button
              style={{ margin: "3px" }}
              size="sm"
              color="info"
              title="View Remarks"
              onClick={() => this.showAuthRemarks(row.auth_remarks)}
            >
              <i className="fa fa-comments" style={{ color: "white" }}></i>
            </Button>
          </span>
        )}
        {hasAttachment && (
          <Button
            style={{ margin: "3px" }}
            size="sm"
            color="primary"
            title="View Attachment"
            onClick={() => this.handleViewAttachment(row)}
          >
            <GrAttachment />
          </Button>
        )}
        <Button
          className="m-1"
          size="sm"
          title={tooltipText.preview}
          onClick={() => {
            this.redirectToOrder("view", row);
          }}
        >
          <i className="fa fa-eye"></i>
        </Button>
      </div>
    );
  };

  async componentDidMount() {
    await this.asyncRollCheck(0);
    if (this.state.permission) {
      this.getMoneyOutWidgets();
      // this.getOverviewData("All", "All");
    }
    await this.checkBussinessPermission();
    this.getDemandTypeLov();
    this.getBranchLov();
  }
  ////////////////-----Show Table LOV and Data------////////////////////
  async checkBussinessPermission() {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission);
    let { isCrumble, isKarakKhel, isEggSpectation } = checkBussinessPermission;
    if (isKarakKhel) {
      this.setState({
        isKarakKhel,
      });
    }
    if (isCrumble) {
      this.setState({
        isCrumble,
      });
      this.checkLineType();
      this.costCenLov();
      let prLov = await priorityLov();
      this.setState({
        priorityLov: prLov[0],
      });
    } else if (isEggSpectation) {
      this.setState({
        isEggSpectation: true,
      });
    } else {
      this.getOverviewData("All", "All");
    }
  }
  checkLineType = () => {
    axios
      .post(
        `${baseurl}/lovs/checkLineType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then(function (response) {
        console.log("checkLineType", response.data.data);
        let resData = response.data.data[0] ? response.data.data[0] : null;
        thisContext.setState({
          checkLineType: resData?.line_type ? resData?.line_type : null,
          demandTypeLov:
            resData?.line_type == 1
              ? expenseTypeLov
              : resData?.line_type == 2
                ? itemTypeLov
                : null,
          lineType:
            resData?.line_type == 1 ? 1 : resData?.line_type == 2 ? 0 : "",
        });
        const lineTypeId =
          resData?.line_type == 1 ? 1 : resData?.line_type == 2 ? 0 : null;
        thisContext.getPoOverviewData(null, null, lineTypeId);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  costCenLov = () => {
    axios
      .post(
        // `${baseurl}/lovs/getProductionCenterDetLov`,
        `${baseurl}/lovs/getCostCenterDetLov`,

        { companyId: companyId, username: username, onlyDept: true },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then(function (response) {
        // let mydata = [];
        let responseData = response.data.data;
        // for (let loop = 0; loop < responseData.length; loop++) {
        //   mydata.push({
        //     id: responseData[loop]["pcDetId"],
        //     label:
        //       responseData[loop]["pcDetCode"] +
        //       " " +
        //       responseData[loop]["pcDetDesc"],
        //   });
        thisContext.setState({
          costCenterLov: responseData,
        });
        // }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  toggleActivityModel = (row) => {
    console.log("row :>> ", row);
    this.setState({
      activityModelIsOpen: !this.state.activityModelIsOpen,
      getActivityByDocNo: row,
    });
  };
  onPageNext = (dataTbleName) => {
    console.log("this.state.activeTab[0]", this.state.activeTab[0]);
    const { activeTab } = this.state;
    const status = activeTab[0] === "All" ? null : activeTab[0];
    let pageCounter = this.state.pageCounter;
    let transactionType = this.state.transactionType;
    let param = "";
    if (transactionType?.id === 1) {
      param = "PUR";
    } else if (transactionType?.id === 2) {
      param = "PUR_RET";
    } else if (transactionType?.id === 3) {
      param = "M";
    } else if (transactionType?.id === 4) {
      param = "SUB";
    } else {
      param = "All";
    }
    this.setState(
      {
        isAllData: false,
        pageCounter: pageCounter + 1,
      },
      () => {
        this.getOverviewData(
          param,
          dataTbleName,
          status,
          this.state.branch?.id,
          this.state.authStatus?.value,
        );
        // Do an API call with this.state.searchTerm
      },
    );
  };
  onPagePrev = (dataTbleName) => {
    const { activeTab } = this.state;
    const status = activeTab[0] === "All" ? null : activeTab[0];
    let pageCounter = this.state.pageCounter;
    let transactionType = this.state.transactionType;
    let param = "";
    if (transactionType?.id === 1) {
      param = "PUR";
    } else if (transactionType?.id === 2) {
      param = "PUR_RET";
    } else if (transactionType?.id === 3) {
      param = "M";
    } else if (transactionType?.id === 4) {
      param = "SUB";
    } else {
      param = "All";
    }

    this.setState(
      {
        isAllData: false,
        pageCounter: pageCounter - 1,
      },
      () => {
        this.getOverviewData(
          param,
          dataTbleName,
          status,
          this.state.branch?.id,
          this.state.authStatus?.value,
        );
        // Do an API call with this.state.searchTerm
      },
    );
  };
  onPageFirst = (dataTableName) => {
    const { activeTab } = this.state;
    const status = activeTab[0] === "All" ? null : activeTab[0];
    let pageCounter = 0;
    let transactionType = this.state.transactionType;
    let param = "";
    if (transactionType?.id === 1) {
      param = "PUR";
    } else if (transactionType?.id === 2) {
      param = "PUR_RET";
    } else if (transactionType?.id === 3) {
      param = "M";
    } else if (transactionType?.id === 4) {
      param = "SUB";
    } else {
      param = "All";
    }
    this.setState(
      {
        isAllData: false,
        pageCounter: pageCounter + 1,
      },
      () => {
        this.getOverviewData(
          param,
          dataTableName,
          status,
          this.state.branch?.id,
          this.state.authStatus?.value,
        );
        // Do an API call with this.state.searchTerm
      },
    );
  };
  onPageLast = (dataTableName) => {
    const { activeTab } = this.state;
    const status = activeTab[0] === "All" ? null : activeTab[0];
    let pageSize = this.state.pageSize;

    let pageCounter = parseInt(this.state.purchaseCount / pageSize);
    // if (dataTableName == "All") {
    //   pageCounter = parseInt(this.state.purchaseCount / pageSize);
    // } else if (dataTableName == "Pending") {
    //   pageCounter = parseInt(this.state.overdueDataCount / pageSize);
    // } else if (dataTableName == "Cancelled/Closed") {
    //   pageCounter = parseInt(this.state.dueDataCount / pageSize);
    // } else if (dataTableName == "Completed") {
    //   pageCounter = parseInt(this.state.dataPaidCount / pageSize);
    // } else if (dataTableName == "Overdue") {
    //   pageCounter = parseInt(this.state.dataPaidCount / pageSize);
    // }

    let transactionType = this.state.transactionType;
    let param = "";
    if (transactionType?.id === 1) {
      param = "PUR";
    } else if (transactionType?.id === 2) {
      param = "PUR_RET";
    } else if (transactionType?.id === 3) {
      param = "M";
    } else if (transactionType?.id === 4) {
      param = "SUB";
    } else {
      param = "All";
    }

    this.setState(
      {
        isAllData: false,
        pageCounter: pageCounter + 1,
      },
      () => {
        this.getOverviewData(
          param,
          dataTableName,
          status,
          this.state.branch?.id,
          this.state.authStatus?.value,
        );
        // Do an API call with this.state.searchTerm
      },
    );
  };
  asyncRollCheck = async (value) => {
    let pathname = "/PurchaseOrder/Overview";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  ////////////////-----Show Table LOV and Data------////////////////////
  getOverviewData(param, lastPageParam, status, branch, authStatus) {
    let isLoadedName = this.props.location.state?.idFromSupplierOverview;
    thisContext.setState({
      loadingResponce: true,
      isLoadedName,
      linkTo: "/PurchaseOrder/form",
    });

    const fetchData = (pageSize) => {
      let offSet =
        parseFloat(thisContext.state.pageCounter - 1) * parseFloat(pageSize);
      let branchId = null;
      const allowedBranches = thisContext.state.toBranchLov
        ? thisContext.state.toBranchLov.filter((b) => b.id !== 0)
        : [];
      if (allowedBranches.length > 0) {
        if (branch && branch !== 0) {
          branchId = [branch];
        } else {
          branchId = allowedBranches.map((b) => b.id);
        }
      }
      axios
        .post(
          `${baseurl}/subsistence/getPurchaseOrderOV`,
          {
            supplierId: isLoadedName,
            companyId,
            username,
            offSet,
            pageSize,
            status,
            currentDate: moment(new Date()).format("YYYY-MM-DD"),
            allData: thisContext.state.isAllData || false,
            branch: branchId,
            amStatus: authStatus && authStatus !== "All" ? authStatus : null,
            searchField: thisContext.state.searchTerm,
            searchCategory: thisContext.state.searchCategory,
          },
          headers,
        )
        .then(function (response) {
          let callData = response.data.data;
          let purchaseCount = response.data.dataCount[0]?.TOT_REC;
          const startRecord = purchaseCount === 0 ? 0 : offSet + 1;
          const endRecord = offSet + callData.length;
          let dataShowPerPage = `${startRecord} - ${endRecord}`;

          thisContext.setState({
            tableData: callData,
            dataShowPerPage: dataShowPerPage,
            purchaseCount: purchaseCount,
            pageSize: pageSize,
            loadingResponce: false,
          });
        })
        .catch(function (error) {
          thisContext.setState({ loadingResponce: false });
          console.log(error);
        });
    };

    // Page size is a company setting that doesn't change mid-session, so fetch
    // it once and reuse the cached value instead of a serial round-trip per load.
    const cachedPageSize = thisContext.state.pageSize;
    if (cachedPageSize) {
      fetchData(cachedPageSize);
    } else {
      axios
        .post(
          `${baseurl}/invoice/getPageSize`,
          {
            companyId,
            username,
          },
          headers,
        )
        .then(function (res) {
          fetchData(res.data.data[0]["page_size"]);
        })
        .catch(function (error) {
          thisContext.setState({ loadingResponce: false });
          console.log(error);
        });
    }
  }
  getPendingPO(demandType, lineType, priority, costCenter) {
    const { activeTab } = this.state;
    let isLoadedName = this.props.location.state?.idFromSupplierOverview;
    const closedStatus = activeTab[0] === "Closed" ? activeTab[0] : null;
    thisContext.setState({
      loadingResponce: true,
      isLoadedName,
      linkTo: "/PurchaseOrder/form",
    });
    let branchIdArr = null;
    const allowedBranches = thisContext.state.toBranchLov
      ? thisContext.state.toBranchLov.filter((b) => b.id !== 0)
      : [];

    let selectedBranchId = this.state.branch?.id;

    if (allowedBranches.length > 0) {
      if (selectedBranchId && selectedBranchId !== 0) {
        branchIdArr = [selectedBranchId];
      } else {
        branchIdArr = allowedBranches.map((b) => b.id);
      }
    }

    let currentPageSize = thisContext.state.pageSize ? parseFloat(thisContext.state.pageSize) : 25;
    
    
    let currentOffSet = parseFloat(thisContext.state.pageCounter - 1) * currentPageSize;
    axios
      .post(
        `${baseurl}/subsistence/getPendingPO`,
        {
          supplierId: isLoadedName,
          companyId,
          username,
          offSet: currentOffSet,
          pageSize: currentPageSize,
          allData: thisContext.state.isAllData || false,
          status: closedStatus,
          demandType,
          lineType: lineType?.trim() === "" ? null : lineType,
          priority,
          costCenter,
          currentDate: moment(new Date()).format("YYYY-MM-DD"),
          branch: branchIdArr,
          amStatus:
            this.state.authStatus && this.state.authStatus.value !== "All"
              ? this.state.authStatus.value
              : null,
          searchField: thisContext.state.searchTerm,
          searchCategory: thisContext.state.searchCategory,
        },
        headers,
      )
      .then(function (response) {
        thisContext.setState({ loadingResponce: false });
        let callData = response.data.data;
        let todayDate = new Date();
        let todayDateUnformat = new Date();
        todayDateUnformat = moment(todayDateUnformat).format("YYYY-MM-DD");
        todayDate = moment(todayDate).format("YYYY-MM-DD");
        let purchaseCount = response.data.dataCount[0]?.TOT_REC;
        const startRecord = purchaseCount === 0 ? 0 : currentOffSet + 1;
        const endRecord = currentOffSet + callData.length;
        let dataShowPerPage = `${startRecord} - ${endRecord}`;

        thisContext.setState({
          tableData: callData,
          dataShowPerPage: dataShowPerPage,
          purchaseCount: purchaseCount,
          loadingResponce: false,
        });
      })
      .catch(function (error) {
        thisContext.setState({ loadingResponce: false });
        console.log(error);
      });
  }
  getBranchLov = () => {
    axios
      .post(
        `${baseurl}/lovs/getDynamicBranchLov`,

        {
          companyId: companyId,
          username: username,
          // custCheck: true,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then(function (response) {
        let responseData = response.data.data;
        let allBranches = {
          id: 0,
          label: "All",
          value: 0,
          master_sub_inv_desc: "All",
        };
        responseData = [allBranches, ...responseData];
        thisContext.setState({
          toBranchLov: responseData,
        });
      })
      .catch(function (error) {
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
        console.log(error);
      });
  };
  getPoOverviewData(status, demandType, lineType, priority, costCenter) {
    const { activeTab } = this.state;
    let isLoadedName = this.props.location.state?.idFromSupplierOverview;
    const closedStatus = activeTab[0] === "Closed" ? activeTab[0] : null;
    thisContext.setState({
      loadingResponce: true,
      isLoadedName,
      linkTo: "/PurchaseOrder/form",
    });
    let branchIdArr = null;
    const allowedBranches = thisContext.state.toBranchLov
      ? thisContext.state.toBranchLov.filter((b) => b.id !== 0)
      : [];

    let selectedBranchId = this.state.branch?.id;

    if (allowedBranches.length > 0) {
      if (selectedBranchId && selectedBranchId !== 0) {
        branchIdArr = [selectedBranchId];
      } else {
        branchIdArr = allowedBranches.map((b) => b.id);
      }
    }
    let currentPageSize = thisContext.state.pageSize
      ? parseFloat(thisContext.state.pageSize)
      : 25;
    let currentOffSet =
      parseFloat(thisContext.state.pageCounter - 1) * currentPageSize;

    const finalLineType =
      typeof lineType === "string"
        ? lineType.trim() || null
        : (lineType ?? null);
    axios
      .post(
        `${baseurl}/subsistence/getPurchaseOrderOV`,
        {
          supplierId: isLoadedName,
          companyId,
          username,
          offSet: currentOffSet,
          pageSize: currentPageSize,
          allData: thisContext.state.isAllData || false,
          status: closedStatus,
          demandType,
          lineType: finalLineType,
          priority,
          costCenter,
          currentDate: moment(new Date()).format("YYYY-MM-DD"),
          branch: branchIdArr,
          amStatus:
            this.state.authStatus && this.state.authStatus.value !== "All"
              ? this.state.authStatus.value
              : null,
              searchField: thisContext.state.searchTerm,
searchCategory: thisContext.state.searchCategory,
        },
        headers,
      )
      .then(function (response) {
        thisContext.setState({ loadingResponce: false });
        let callData = response.data.data;
        let todayDate = new Date();
        let todayDateUnformat = new Date();
        todayDateUnformat = moment(todayDateUnformat).format("YYYY-MM-DD");
        todayDate = moment(todayDate).format("YYYY-MM-DD");
        let purchaseCount = response.data.dataCount[0]?.TOT_REC;
        const startRecord = purchaseCount === 0 ? 0 : currentOffSet + 1;
        const endRecord = currentOffSet + callData.length;
        let dataShowPerPage = `${startRecord} - ${endRecord}`;

        thisContext.setState({
          tableData: callData,
          dataShowPerPage: dataShowPerPage,
          purchaseCount: purchaseCount,
          loadingResponce: false,
        });
      })
      .catch(function (error) {
        thisContext.setState({ loadingResponce: false });
        console.log(error);
      });
  }
  getMoneyOutWidgets = () => {
    axios
      .post(
        `${baseurl}/subsistence/getMoneyOutWidgets`,
        {
          companyId,
          username,
        },
        headers,
      )
      .then(function (res) {
        let wDue = 0,
          wRecurring = 0,
          wOverdue = 0;
        let data = res.data;
        wDue = data?.resDue?.[0]?.totalSum;
        wOverdue = data?.resOverdue?.[0]?.totalSum;
        thisContext.setState({
          wOverdue,
          wDue,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  handleViewAttachment = (row) => {
    this.setState({
      showAttachmentModal: true,
      selectedRowDetails: row,
    });
  };

  closeAttachmentModal = () => {
    this.setState({
      showAttachmentModal: false,
      selectedRowDetails: null,
    });
  };
  handleBranchChange = (branch) => {
    this.setState({ branch, pageCounter: 1 }); // Reset to page 1 on filter change

    // Maintain the current tab status when filtering
    const status =
      this.state.activeTab[0] === "All" ? null : this.state.activeTab[0];
    const branchId = branch ? branch.id : 0;

    if (status === "Pending") {
      this.getPendingPO(
        this.state.demandType?.id,
        this.state.lineType,
        this.state.priority?.id,
        this.state.costCenter?.id,
      );
    } else {
      this.getOverviewData(
        "All",
        "All",
        status,
        branchId,
        this.state.authStatus?.value,
      );
    }
  };
  handleSearchCategoryChange = (selectedOption) => {
    this.setState({ searchCategory: selectedOption });
  };

  handleSearchTermChange = (term) => {
    this.setState({ searchTerm: term, pageCounter: 1 }, () => {
      const status =
        this.state.activeTab[0] === "All" ? null : this.state.activeTab[0];
      if (status === "Pending") {
        this.getPendingPO(
          this.state.demandType?.id,
          this.state.lineType,
          this.state.priority?.id,
          this.state.costCenter?.id,
        );
      } else {
        this.getOverviewData(
          "All",
          "All",
          status,
          this.state.branch?.id,
          this.state.authStatus?.value,
        );
      }
    });
  };
  ////////////////------End-----////////////////////
  render() {
    const {
      clientNameHeading,
      activityModelIsOpen,
      loadingResponce,
      closePoModelIsOpen,
      logPoModelIsOpen,
      getActivityByDocNo,
      curDesc,
      wDue,
      TotalAmount,
      balanceAmount,
      records,
      wRecurring,
      closeDate,
      wOverdue,
      remarks,
      tableData,
      checkLineType,
      isCrumble,
      isEggSpectation,
    } = this.state;

    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 10,
      pageStartIndex: 1,
      paginationSize: 10,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: tableData?.length,
        },
      ],
    };

    const x = this.state.divcontainer;
    if (!this.state.logInStatus) return <Redirect to="/login" />;
    else if (loadingResponce) return <Responseloader />;

    return this.state.redirectPurchBill ? (
      <Redirect
        push
        to={{
          pathname: "/PurchaseOrder/Form",
          state: {
            id: this.state.idEdits,
            updateCheck: this.state.updateCheck,
          },
        }}
      />
    ) : this.state.redirectPurchaseOrderAgainst ? (
      <Redirect
        push
        to={{
          // pathname: "/PurchaseAgainstPO_eggs",
          pathname: "/PurchaseOrderAgainst/Form",
          state: {
            id: this.state.idEdits,
            updateCheck: this.state.updateCheck,
          },
        }}
      />
    ) : this.state.redirectPurchaseOrderAgainstKK ? (
      <Redirect
        push
        to={{
          pathname: "/PurchaseAgainstPO_KK",
          state: {
            id: this.state.idEdits,
            updateCheck: this.state.updateCheck,
          },
        }}
      />
    ) : this.state.redirectPoToGrn ? (
      <Redirect
        push
        to={{
          pathname: "/grnFormAgainstPO",
          state: {
            id: this.state.idEdits,
            updateCheck: this.state.updateCheck,
          },
        }}
      />
    ) : this.state.redirectToPrint ? (
      <Redirect
        push
        to={{
          pathname: "/purchasePrintView",
          state: {
            companyId: this.state.companyId,
            id: this.state.invoiceId,
            printType: "Purchase",
            url: this.props.location.pathname,
            updateCheck: this.props.location.state?.updateCheck,
            headerPrefix: this.state.headerPrefix,
          },
        }}
      />
    ) : this.state.redirectPurchase ? (
      <Redirect
        push
        to={{
          pathname: "/CreateBill",
          goBackUrl: "/PurchaseOrder/Overview",
          state: {
            id: this.state.idEdits,
            updateCheck: this.state.updateCheck,
          },
        }}
      />
    ) : (
      <div className="animated fadeIn">
        <div className="row">
          <Col sm="4" md="4">
            <Card>
              <img
                src={bar1}
                style={{
                  height: "98px",
                  left: "-8px",
                  top: "-4px",
                  position: "absolute",
                }}
                alt="Default"
              />

              <CardBody style={{ padding: "1rem" }}>
                <div className="row">
                  <div className="col-8">
                    <div
                      className="text-muted text-uppercase font-weight-bold"
                      style={{ fontSize: "16px" }}
                    >
                      OverDue
                    </div>
                    <div style={{ color: "#84CE3B" }}>
                      <h4 style={{ fontSize: "14px", marginTop: "5px" }}>
                        {curDesc} {dueFormatorsComma2(wOverdue)}
                      </h4>
                    </div>
                  </div>

                  <div className="col-4" style={{ textAlign: "right" }}>
                    <img
                      src={calender}
                      style={{
                        backgroundColor: "#84CE3B",
                        padding: "9px",
                        height: "51px",
                        borderRadius: "12px",
                        marginTop: "3px",
                        marginLeft: "5px",
                      }}
                      alt="Default"
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col sm="4" md="4">
            <Card>
              <img
                src={bar2}
                style={{
                  height: "98px",
                  left: "-8px",
                  top: "-4px",
                  position: "absolute",
                }}
                alt="Default"
              />

              <CardBody style={{ padding: "1rem" }}>
                <div className="row">
                  <div className="col-8">
                    <div
                      className="text-muted text-uppercase font-weight-bold"
                      style={{ fontSize: "16px" }}
                    >
                      Due
                    </div>
                    <div style={{ color: "#FFBC0C" }}>
                      <h4 style={{ fontSize: "14px", marginTop: "5px" }}>
                        {curDesc} {dueFormatorsComma2(wDue)}
                      </h4>
                    </div>
                  </div>

                  <div className="col-4" style={{ textAlign: "right" }}>
                    <img
                      src={clock}
                      style={{
                        backgroundColor: "#FFBC0C",
                        padding: "9px",
                        height: "51px",
                        borderRadius: "12px",
                        marginTop: "3px",
                        marginLeft: "9px",
                      }}
                      alt="Default"
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col sm="4" md="4">
            <Card>
              <img
                src={bar4}
                style={{
                  height: "98px",
                  left: "-8px",
                  top: "-4px",
                  position: "absolute",
                }}
                alt="Default"
              />

              <CardBody style={{ padding: "1rem" }}>
                <div className="row">
                  <div className="col-8">
                    <div
                      className="text-muted text-uppercase font-weight-bold"
                      style={{ fontSize: "16px" }}
                    >
                      Recurring
                    </div>
                    <div style={{ color: "#3B1181" }}>
                      <h4 style={{ fontSize: "14px", marginTop: "5px" }}>
                        {curDesc} {dueFormatorsComma2(wRecurring)}
                      </h4>
                    </div>
                  </div>
                  <div className="col-4" style={{ textAlign: "right" }}>
                    <img
                      src={layer1}
                      style={{
                        backgroundColor: "#3B1181",
                        padding: "9px",
                        height: "51px",
                        borderRadius: "12px",
                        marginTop: "3px",
                        marginLeft: "9px",
                      }}
                      alt="Default"
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </div>

        <div className="animated fadeIn">
          <div className="O-V-boarder">
            <div className="O-V-heading-bar">
              <div className="col-md-6">
                {this.state.isLoadedName ? (
                  <div className="p-2">
                    <h4>Supplier: {clientNameHeading}</h4>
                  </div>
                ) : (
                  <div className="p-2">
                    <h4>Purchase Order Overview</h4>
                    {/* <h4>Composite GRN Overview</h4> */}
                  </div>
                )}
              </div>
              <div
                className=" col-md-6"
                // hidden={companyNameParam === "Crumble" ? true : false} Tauqeer
              >
                <div className="row OV_Res_Bar float-right text-right">
                  <Link
                    to={{
                      pathname: "/PurchaseOrder/form",
                      goBackUrl: "/PurchaseOrder/Overview",
                    }}
                  >
                    <button
                      class="btn btn-outline-success rounded-pill"
                      disabled={this.state.rolesPermission}
                    >
                      <i className="fa fa-plus pr-2" aria-hidden="true" />
                      Purchase Order
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            <Row>
              <Col xs="12" md="12" className="mb-4">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab[0] === "All"}
                      onClick={() => {
                        this.setState({ activeTab: ["All"] });
                        this.getOverviewData(
                          "",
                          "",
                          null,
                          this.state.branch?.id,
                        );
                      }}
                    >
                      All
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab[0] === "Pending"}
                      onClick={() => {
                        this.setState({ activeTab: ["Pending"] });
                        this.getPendingPO();
                      }}
                    >
                      Pending
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab[0] === "Closed"}
                      onClick={() => {
                        this.setState({ activeTab: ["Closed"] });
                        this.getOverviewData(
                          "",
                          "",
                          "Closed",
                          this.state.branch?.id,
                        );
                      }}
                    >
                      Cancelled/Closed
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab[0] === "Completed"}
                      onClick={() => {
                        this.setState({ activeTab: ["Completed"] });
                        this.getOverviewData(
                          "",
                          "",
                          "Completed",
                          this.state.branch?.id,
                        );
                      }}
                    >
                      Completed
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={this.state.activeTab[0] === "Overdue"}
                      onClick={() => {
                        this.setState({ activeTab: ["Overdue"] });
                        this.getOverviewData(
                          "",
                          "",
                          "Overdue",
                          this.state.branch?.id,
                        );
                      }}
                    >
                      Overdue
                    </NavLink>
                  </NavItem>
                </Nav>
                <div className="bg-white p-3">
                  <div translate="no" class="row">
                    {isEggSpectation ? (
                      <>
                        <div translate="no" className="col-md-5">
                          <Select
                            isClearable
                            value={this.state.branch || ""}
                            options={this.state.toBranchLov}
                            onChange={this.handleBranchChange}
                            name="branch"
                            placeholder={"-- Select Branch --"}
                          />
                        </div>
                        <div translate="no" className="col-md-5">
                          <Select
                            isClearable
                            value={this.state.authStatus || ""}
                            options={this.authoptions}
                            onChange={this.handleAuthStatusChange}
                            name="Status"
                            placeholder={"-- Select Status --"}
                          />
                        </div>
                      </>
                    ) : null}
                    {isCrumble ? (
                      <>
                        {" "}
                        <div className="col-md-2">
                          <Label style={{ fontWeight: "bold" }}>
                            Line Type
                          </Label>
                          <Input
                            type="select"
                            id="lineType"
                            name="lineType"
                            className="form-control"
                            // disabled={this.state.disabled}
                            value={this.state.lineType} // <-- controlled by state
                            // onChange={this.lineTypeChange(e)}
                            onChange={(e) => this.handleLineChange(e)}
                            required
                          >
                            <option value="select">-- Select --</option>
                            {console.log(
                              "this.state.lineType",
                              this.state.lineType,
                            )}
                            {console.log("checkLineType", checkLineType)}
                            {checkLineType === 0 ||
                              (checkLineType == null && (
                                <>
                                  <option translate="no" value="1">
                                    Expense
                                  </option>
                                  <option translate="no" value="0">
                                    Item
                                  </option>
                                </>
                              ))}

                            {checkLineType === 1 && (
                              <option translate="no" value="1">
                                Expense
                              </option>
                            )}

                            {checkLineType === 2 && (
                              <option translate="no" value="0">
                                Item
                              </option>
                            )}
                          </Input>
                        </div>
                        <div class="col-md-2 mt-4">
                          <Select
                            isClearable
                            value={this.state.demandType || ""}
                            options={this.state.demandTypeLov}
                            onChange={(e) =>
                              this.handleToChangeOpen(e, "demandType")
                            }
                            //  required
                            isDisabled={
                              this.state.lineType == 0 ||
                              this.state.lineType == 1
                                ? false
                                : true
                            }
                            name="demandType"
                            placeholder={"-- Select Demand Type --"}
                          />
                        </div>
                        <div class="col-md-2 mt-4">
                          <Select
                            isClearable
                            value={this.state.priority || ""}
                            options={this.state.priorityLov}
                            onChange={(e) =>
                              this.handleToChangeOpen(e, "priority")
                            }
                            //  required
                            isDisabled={
                              this.state.lineType == 0 ||
                              this.state.lineType == 1
                                ? false
                                : true
                            }
                            name="priority"
                            placeholder={"-- Select priority Type --"}
                          />
                        </div>
                        <div class="col-md-2 mt-4">
                          <Select
                            isClearable
                            value={this.state.costCenter || ""}
                            options={this.state.costCenterLov}
                            onChange={(e) =>
                              this.handleToChangeOpen(e, "costCenter")
                            }
                            //  required
                            isDisabled={
                              this.state.lineType == 0 ||
                              this.state.lineType == 1
                                ? false
                                : true
                            }
                            name="costCenter"
                            placeholder={"-- Select Cost Center --"}
                          />
                        </div>
                        <div class="col-md-2">
                          <Button
                            size="md"
                            color="success"
                            className="mr-1"
                            // onClick={() =>
                            //   this.getPoOverviewData(
                            //     null,
                            //     this.state.demandType?.id,
                            //     this.state.lineType,
                            //     this.state.priority?.id,
                            //     this.state.costCenter?.id
                            //   )
                            // }
                            onClick={() => {
                              // Condition check
                              if (this.state.activeTab[0] !== "Pending") {
                                // Pehla function chalayen
                                this.getPoOverviewData(
                                  null,
                                  this.state.demandType?.id,
                                  this.state.lineType,
                                  this.state.priority?.id,
                                  this.state.costCenter?.id,
                                );
                              } else {
                                // Doosra function chalayen
                                this.getPendingPO(
                                  this.state.demandType?.id,
                                  this.state.lineType,
                                  this.state.priority?.id,
                                  this.state.costCenter?.id,
                                );
                              }
                            }}
                            style={{ marginTop: "30px" }}
                          >
                            Find
                          </Button>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div translate="no" class="row">
                    <div class="col-md-6">
                      <p style={{ position: "relative", top: "45px" }}>
                        Showing {thisContext.state.dataShowPerPage} of{" "}
                        {thisContext.state.purchaseCount}{" "}
                      </p>
                      <div
                        style={{
                          position: "relative",
                          left: "200px",
                          top: "6px",
                        }}
                      >
                        <button
                          disabled={
                            thisContext.state.pageCounter > 1 ? false : true
                          }
                          hidden={this.state.activeTab[0] === "Pending"}
                          className="btn btn-light border "
                          onClick={() => this.onPageFirst("All")}
                        >
                          First
                        </button>
                        <button
                          className="btn btn-light border"
                          disabled={
                            thisContext.state.pageCounter > 1 ? false : true
                          }
                          onClick={() => this.onPagePrev("All")}
                          hidden={this.state.activeTab[0] === "Pending"}
                        >
                          Prev
                        </button>
                        <button
                          disabled={
                            thisContext.state.pageCounter *
                              thisContext.state.pageSize >=
                            thisContext.state.purchaseCount
                              ? true
                              : false
                          }
                          hidden={this.state.activeTab[0] === "Pending"}
                          className="btn btn-light border"
                          onClick={() => this.onPageNext("All")}
                        >
                          Next
                        </button>
                        <button
                          disabled={
                            thisContext.state.pageCounter *
                              thisContext.state.pageSize >=
                            thisContext.state.purchaseCount
                              ? true
                              : false
                          }
                          hidden={this.state.activeTab[0] === "Pending"}
                          className="btn btn-light border"
                          onClick={() => this.onPageLast("All")}
                        >
                          Last
                        </button>
                        <button
                          disabled={
                            thisContext.state.pageCounter *
                              thisContext.state.pageSize >=
                            thisContext.state.purchaseCount
                              ? true
                              : false || thisContext.state.isAllData
                          }
                          hidden={this.state.activeTab[0] === "Pending"}
                          className="btn btn-light border"
                          onClick={() => {
                            this.setState(
                              { isAllData: true, pageCounter: 1 },
                              () => {
                                this.getPoOverviewData();
                              },
                            );
                          }}
                        >
                          All
                        </button>
                      </div>
                    </div>
                  </div>
                  <SearchBar
                    searchCategory={this.state.searchCategory}
                    searchOptions={this.state.searchOptions}
                    searchTerm={this.state.searchTerm}
                    onSearchCategoryChange={this.handleSearchCategoryChange}
                    onSearchExecute={this.handleSearchTermChange}
                  />
                  <div translate="no">
                    <BootstrapTable
                      remote={true}
                      data={tableData}
                      striped
                      hover
                      // search
                      tableHeaderClass="rpr_header"
                      tableBodyClass="rpr_body"
                      containerClass="rpr_container"
                      options={options}
                    >
                      <TableHeaderColumn
                        dataField="formated_purch_order_date"
                        dataAlign="center"
                        width="10%"
                      >
                        ISSUED
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="dem_type_name"
                        dataAlign="right"
                        width="10%"
                        hidden={!isCrumble}
                        // dataFormat={dueFormatorsComma}
                        // columnTitle={columnHover}
                      >
                        Demand Type
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="supplierName"
                        dataAlign="left"
                        width="20%"
                      >
                        NAME
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="branch_name"
                        dataAlign="left"
                        width="10%"
                      >
                        BRANCH
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="document_no"
                        dataAlign="center"
                        width="5%"
                        dataFormat={addZeroTFormator}
                        isKey={true}
                      >
                        NO
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="ORDERED_AMT"
                        dataAlign="right"
                        width="15%"
                        dataFormat={dueFormatorsComma}
                      >
                        ORDERED
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="PUR_AMT"
                        dataAlign="right"
                        width="15%"
                        dataFormat={dueFormatorsComma}
                        columnTitle={columnHover}
                      >
                        PURCHASED
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataAlign="right"
                        dataField="purch_order_id"
                        width="25%"
                        dataFormat={this.statusFormator}
                      >
                        STATUS
                      </TableHeaderColumn>
                    </BootstrapTable>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <AttachmentViewModal
          show={this.state.showAttachmentModal}
          onHide={this.closeAttachmentModal}
          row={this.state.selectedRowDetails}
          moduleName={"Purchase Order"}
          fieldMap={{
            docNo: "document_no",
            date: "formated_purch_order_date",
            type: "dem_type_name",
            attachment: "attachment_file",
          }}
        />
        <Modal show={false} size="md" onHide={this.togglePermission}>
          <Modal.Header
            closeButton
            className="Creative-Invoice-header-styling p-3"
          >
            <Modal.Title>Access Denied!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Dear Username, your user roll is not allowed to access.
          </Modal.Body>
        </Modal>

        <Modal
          show={activityModelIsOpen}
          size="xl"
          onHide={this.toggleActivityModel}
          backdrop="static"
        >
          <Modal.Header
            closeButton
            onClick={this.toggleActivityModel}
            className=" Creative-Invoice-header-styling"
          >
            <h4> Activity Logs </h4>{" "}
          </Modal.Header>
          <Modal.Body className="">
            <ActivityLogs
              closeModel={"closeModel"}
              rowData={getActivityByDocNo}
              activeName={"Purchase Order"}
            />
          </Modal.Body>
        </Modal>

        {/*modal Log of PO Order*/}
        <Modal
          show={logPoModelIsOpen}
          size="md"
          onHide={this.toggleLogPoModal}
          backdrop="static"
        >
          <Modal.Header
            closeButton
            onClick={() => this.toggleLogPoModal()}
            className=" Creative-Invoice-header-styling"
          >
            <h4>Purchase Order Log </h4>{" "}
          </Modal.Header>
          <Modal.Body className="">
            <Container>
              <Row className="  ">
                <Col xs="8" className="border h5 py-2">
                  Purchase Order Amount
                </Col>
                <Col xs="4" className=" border h5 py-2 text-right ">
                  {TotalAmount}
                </Col>
              </Row>
              <Row className="">
                <Col xs="4" className="border h6 p-2">
                  Date
                </Col>
                <Col xs="4" className="border h6 p-2 text-right">
                  Amount
                </Col>
                <Col xs="4" className="border h6 p-2 text-right">
                  Action
                </Col>
              </Row>
              {records?.map(
                ({ PURCH_INVOICE_DATE, AMT, PURCH_INVOICE_ID }, i) => (
                  <Row className=" ">
                    <Col xs="4" className="border">
                      {PURCH_INVOICE_DATE}
                    </Col>
                    <Col xs="4" className="border text-right">
                      {AMT}
                    </Col>
                    <Col xs="4" className="border p-1 text-right">
                      <Button
                        size="sm"
                        color="primary"
                        className="p-1"
                        onClick={() => {
                          this.redirectToOrder("showPurchase", {
                            PURCH_INVOICE_ID,
                          });
                        }}
                      >
                        {" "}
                        Show Purchase
                      </Button>
                    </Col>
                  </Row>
                ),
              )}
              <Row className=" ">
                <Col xs="4" className="border h6 py-2">
                  Balance Amount
                </Col>
                <Col xs="8" className="border h6 py-2 text-right">
                  {balanceAmount}
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
        {/*modal close Po*/}
        <Modal
          show={closePoModelIsOpen}
          size="md"
          onHide={this.toggleClosePoModal}
          backdrop="static"
        >
          <Modal.Header
            closeButton
            onClick={() => this.toggleClosePoModal()}
            className=" Creative-Invoice-header-styling"
          >
            <h4> Close PO </h4>{" "}
          </Modal.Header>
          <Modal.Body className="">
            <div className="row">
              <ReactDatePicker
                label="Close Date:"
                className="col-md-6 col-lg-6 col-xl-6"
                isSelected={closeDate}
                isDisabled={true}
              />
              <div className="col-md-12 my-1">
                <Label> Remarks:</Label>
                <Input
                  rows="3"
                  type="textarea"
                  id="remarks"
                  name="remarks"
                  className="form-control"
                  value={remarks}
                  onChange={(e) => {
                    this.setState({ remarks: e.target.value });
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 float-right ">
                <Button color="secondary" onClick={this.toggleClosePoModal}>
                  Cancel
                </Button>
                <Button color="primary" className="mx-2" onClick={this.closePo}>
                  Close
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <GrnTrackingModal
          isOpen={this.state.grnTrackingModalOpen}
          toggle={this.toggleGrnTrackingModal}
          data={this.state.grnTrackingData}
          totalPoQty={this.state.grnTrackingTotalPO}
        />
      </div>
    );
  }
}
export default Overview;
